"use client"

import { useAuth } from "@/context/auth-context"
import { AuthOverlay } from "./auth-overlay"

export function AuthModal() {
  const { showAuthModal, setShowAuthModal, requireAuth } = useAuth()

  return (
    <AuthOverlay
      isOpen={showAuthModal}
      onClose={() => setShowAuthModal(false)}
      onSuccess={() => setShowAuthModal(false)}
      allowClose={!requireAuth}
    />
  )
}
